/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LiveStreamUser
 */
export interface LiveStreamUser {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUser
     */
    _id?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUser
     */
    profilePicture?: string;
}

/**
 * Check if a given object implements the LiveStreamUser interface.
 */
export function instanceOfLiveStreamUser(value: object): value is LiveStreamUser {
    return true;
}

export function LiveStreamUserFromJSON(json: any): LiveStreamUser {
    return LiveStreamUserFromJSONTyped(json, false);
}

export function LiveStreamUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveStreamUser {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'username': json['username'] == null ? undefined : json['username'],
        'profilePicture': json['profilePicture'] == null ? undefined : json['profilePicture'],
    };
}

export function LiveStreamUserToJSON(json: any): LiveStreamUser {
    return LiveStreamUserToJSONTyped(json, false);
}

export function LiveStreamUserToJSONTyped(value?: LiveStreamUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'username': value['username'],
        'profilePicture': value['profilePicture'],
    };
}

